import React from 'react';
import { func, string } from 'prop-types';
import { connect } from 'react-redux';
import { translate, Trans } from 'react-i18next';
import classnames from 'classnames/bind';

import { actions as reportActions } from '@dragonfruit/redux/report';
import { getSignupEmail } from '@dragonfruit/redux/signup';
import { resendEmail } from '@dragonfruit/redux/sendEmail';

import { useCountDownTimer } from '@dragonfruit/hooks/timer';
import { RESEND_EMAIL_INTERVAL_SECONDS } from '@dragonfruit/constants/resendEmailSeconds';

import EveImg from '@dragonfruit/images/eve.svg';
import styles from './EmailNotVerified.scss';

const cx = classnames.bind(styles);

const mapStateToProps = state => ({
  unverifiedEmail: getSignupEmail(state),
});

function EmailNotVerified({
  t,
  toggleReportForm,
  unverifiedEmail,
  resendEmail,
}) {
  const [counter, isCounting, restartCounter] = useCountDownTimer(
    RESEND_EMAIL_INTERVAL_SECONDS,
    false
  );

  const handleClickResendEmail = () => {
    if (isCounting) return;
    restartCounter();
    resendEmail();
  };

  const handleClickReport = () => {
    toggleReportForm();
  };

  return (
    <div className={styles.root}>
      <div className={styles.card}>
        <div className={styles.content}>
          <h3 className={styles.heading}>{t('emailNotVerified.title')}</h3>
          <p className={styles.description}>
            <Trans i18nKey="emailNotVerified.description">
              Verification mail sent to
              <strong>{{ email: unverifiedEmail }}</strong>
              to verify.
            </Trans>
          </p>

          <p className={styles.resend}>
            <div>{t('emailNotVerified.canNotFind')}</div>

            <span
              onClick={handleClickResendEmail}
              className={cx(styles.resendText, {
                disabled: isCounting,
              })}
            >
              {t('emailNotVerified.resend')}
            </span>

            {isCounting && <span className={styles.counter}>({counter})</span>}
          </p>

          <p className={styles.troubleHint}>
            <Trans i18nKey="emailNotVerified.gotTrouble">
              Still got truble?
              <span className={styles.hintText} onClick={handleClickReport}>
                Contact our service
              </span>
            </Trans>
          </p>
        </div>
        <img className={styles.illustration} src={EveImg} />
      </div>
    </div>
  );
}

EmailNotVerified.propTypes = {
  resendEmail: func.isRequired,
  t: func.isRequired,
  toggleReportForm: func.isRequired,
  unverifiedEmail: string.isRequired,
};

export default translate(['emailNotVerified', 'seo'])(
  connect(mapStateToProps, {
    toggleReportForm: reportActions.toggleReportForm,
    resendEmail,
  })(EmailNotVerified)
);



// WEBPACK FOOTER //
// ./app/containers/Login/components/EmailNotVerified/EmailNotVerified.jsx